import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { companyService } from "../../services/company";
import { useAuthStore } from "../../store/authStore";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
const AccountPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "", 
    address: "",
    mobilePhones: "",
    notes: "",
    gender: null,
    status: true,
  });
    const userId = useAuthStore((state) => state.userId);
  
    const { data: user, isLoading, isError } = useQuery({
        queryKey: ["users", userId],
        queryFn:   () =>  companyService.getUser(userId),   
            
      });
      
      
   
      
      useEffect(() => {
        if (user) {
          setFormData({
            userId:userId,
            fullName: user.fullName ,
            email: user.email ,
            currentId:user.currentId,
            address: user.address ,
            mobilePhones: user.mobilePhones ,
            notes: user.notes,
            gender: user.gender,
          // varsayılan true
          });
        }
      }, [user]);

  const [errors, setErrors] = useState({});
  const [errorsPass, setErrorsPass] = useState({});
  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Boş bırakılamaz.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Boş bırakılamaz.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Hata yoksa true döner
  };
  const validateFormPass = () => {
    const newErrors = {};

    if (!newPassword.trim()) {
      newErrors.password = "Boş bırakılamaz.";
    }

    setErrorsPass(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const [newPassword, setNewPassword] = useState("");
  const handleDropdownChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {  mutation.mutate(formData);
    }
  };  const handleSubmitPass = (e) => {
    e.preventDefault();
    if (validateForm()) { passwordMutation.mutate({ password: newPassword, userId });
    }
  };

  const mutation = useMutation({
    mutationFn: (userData) => {    
      return   companyService.updateUser(userData) 
    },
    onSuccess: () => {
       
      toast.success("Kullanıcı güncellendi"
      
      ); 
    }, 
    onError: () => {
      toast.error("Bir hata oluştu");
    },
  });
 const passwordMutation = useMutation({
    mutationFn: (userData) => {
     
      return  companyService.updateUserPassword(userData);
    },
    onSuccess: () => { 
      toast.success(
     "Kullanıcı şifresi güncellendi"  
      ); 
    },
    onError: () => {
      toast.error("Bir hata oluştu");
    },
  });
  const handleGeneratePassword = () => {
    const generatedPassword = Math.random().toString(36).slice(-8);
    setNewPassword(generatedPassword);
  };
  const changePasswordText = (e) => {
    const { name, value } = e.target;
    setNewPassword(value)
  };
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
      {/* User Info Section */}
      <div className="p-card px-3 pb-4">
        <h2>Kullanıcı Bilgileri</h2>
        <div className="grid px-2 mt-3">
          <div className="col-12 md:col-6 ">
            <div className="p-inputgroup flex-1 w-12    ">
              <span className="p-inputgroup-addon w-7rem">Ad Soyad</span>
              <InputText disabled={isLoading}
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
              />
              {errors.fullName && (
                <span className="p-inputgroup-addon max-w-max">
                  <small className="p-error">{errors.fullName}</small>
                </span>
              )}
            </div>
          </div>
          <div className="col-12 md:col-6 ">
            <div className="p-inputgroup flex-1 w-12    ">
              <span className="p-inputgroup-addon w-7rem">Email</span>
              <InputText disabled={isLoading}
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && (
                <span className="p-inputgroup-addon max-w-max">
                  <small className="p-error">{errors.email}</small>
                </span>
              )}
            </div>
          </div>

          <div className="col-12 md:col-6 ">
            <div className="p-inputgroup flex-1 w-12    ">
              <span className="p-inputgroup-addon w-7rem">Adres</span>
              <InputText disabled={isLoading}
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-12 md:col-6 ">
            <div className="p-inputgroup flex-1 w-12    ">
              <span className="p-inputgroup-addon w-7rem">Telefon</span>
              <InputText disabled={isLoading}
                id="mobilePhones"
                name="mobilePhones"
                value={formData.mobilePhones}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-12 md:col-6 ">
            <div className="p-inputgroup flex-1 w-12    ">
              <span className="p-inputgroup-addon w-7rem">Not</span>
              <InputText disabled={isLoading}
                id="notes"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="col-12 md:col-6 ">
            <div className="p-inputgroup flex-1 w-12    ">
              <span className="p-inputgroup-addon w-7rem">Cinsiyet</span>
              <Dropdown  disabled={isLoading}
                id="gender"
                name="gender"
                value={formData.gender}
                options={[
                  { label: "Erkek", value: 0 },
                  { label: "Kadın", value: 1 },
                ]}
                onChange={(e) => handleDropdownChange("gender", e.value)}
              />
            </div>
          </div>
        </div>
        <div className="  col-12 ">
          <Button
            className="w-full " loading={isLoading}
            label={"Güncelle"}
            icon="pi pi-check"
            severity={"success"}
            outlined
            onClick={handleSubmit}
          />
        </div>
      </div>

      {/* Password Reset Section */}
      <div className="p-card px-3 pb-4  w-full">
        <h2>Şifre Yenileme</h2>
        <div className="grid mt-3  pl-2 w-full">
          <div className="col-12">
            <div className="p-inputgroup flex-1 w-full">
              <span className="p-inputgroup-addon w-7rem">Yeni Şifre</span>
              <Password
                           id="userpassword"
                           name="userpassword"
                           feedback={false}
                           value={newPassword}
                           onChange={(e) => changePasswordText(e)}
                           weakLabel="Kolay"
                           mediumLabel="Orta"
                           strongLabel="Zor"
                           toggleMask
                           promptLabel="Güçlü şifrenizi giriniz."
                           inputStyle={{
                             width: "100%",
                             borderTopLeftRadius: 0,
                             borderBottomLeftRadius: 0,
                             borderBottomRightRadius:   0,
                             borderTopRightRadius:  0,
                           }}
                           pt={{ iconField: { root: { className: "w-full" } } }}
                         />
          
             <Button
                      label="Üret"
                      icon="pi pi-refresh"
                      onClick={handleGeneratePassword}
                      severity="info"
                    />
                        {errors.password && (
                          <span className="p-inputgroup-addon max-w-max">
                            <small className="p-error">{errors.password}</small>
                          </span>
                        )}  </div>
          </div>
        </div>
        <div className="  col-12 ">
          <Button 
            className="w-full "
            label={"Güncelle"}
            icon="pi pi-check"
            severity={"success"}
            outlined
            onClick={handleSubmitPass}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
